import styled from '../../styles/styled';
export const Container = styled.div({});
export const VertNavButtonsWrapper = styled.div(props => ({
    position: 'relative',
    height: 'auto',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '20px 0 0',
    zIndex: props.theme.layers.ui,
}));
export const Wrapper = styled.div(({ theme }) => ({
    background: theme.colors.blue80,
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.2s',
}), ({ expanded }) => ({
    minWidth: expanded ? '212px' : '56px',
    width: expanded ? '212px' : '56px',
}));
export const VertNavIconWrapper = styled.div({
    display: 'flex',
    minWidth: '37px',
    height: '37px',
    justifyContent: 'center',
    alignItems: 'center',
});
export const VertNavButtonGroup = styled.div({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
});
export const NavBarToggle = styled.div(({ expanded }) => ({
    position: 'absolute',
    transition: 'all 200ms',
    bottom: '12px',
    left: expanded ? '212px' : '56px',
    transform: 'translateX(-50%)',
    zIndex: -1,
}));
export const VertNavIcon = styled.div(({ expanded, theme, onClick }) => {
    return {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        marginTop: theme.space[1],
        fontSize: '1rem',
        height: '38px',
        marginBottom: '20px',
        whiteSpace: 'nowrap',
        width: '100%',
        justifyContent: 'flex-start',
        paddingLeft: expanded ? '24px' : '10px',
        transition: 'padding 200ms ease',
        cursor: onClick ? 'pointer' : 'auto',
        '>div': {
            minWidth: 'auto',
        },
    };
});
export const VertNavIconButton = styled.button(({ theme, nested, transparentHover, active }) => {
    return {
        display: 'flex',
        flexDirection: 'row',
        transition: '.2s linear all',
        cursor: 'pointer',
        border: 0,
        padding: 0,
        fontSize: '1rem',
        height: '56px',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        width: '100%',
        justifyContent: 'flex-start',
        paddingLeft: theme.space[3],
        background: active
            ? theme.colors.blue50
            : nested
                ? theme.colors.darkBluePearlSemiTransparent
                : 'transparent',
        ':hover': {
            background: transparentHover ? 'transparent' : theme.colors.blue50,
        },
    };
}, ({ expanded, theme, nested }) => {
    if (expanded) {
        return {
            paddingLeft: nested ? theme.space[4] : theme.space[3],
        };
    }
});
//# sourceMappingURL=vertical_icon_bar.styles.js.map